(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_cart-reservation-timer"] && !Shopify.designMode) return;
  try {
    (function(){
    function tick(el){
      var minsEl = el.querySelector('[data-vc-cart-mins]');
      var secsEl = el.querySelector('[data-vc-cart-secs]');
      var dur = parseInt(minsEl ? minsEl.textContent : '15', 10);
      var remaining = dur * 60;
      function update(){
        if (remaining <= 0) { el.style.display = 'none'; return; }
        var m = Math.floor(remaining / 60);
        var s = remaining % 60;
        if (minsEl) minsEl.textContent = m;
        if (secsEl) secsEl.textContent = String(s).padStart(2, '0');
        remaining--;
      }
      update();
      setInterval(update, 1000);
    }
    function init(){
      document.querySelectorAll('[data-vc-cart-reserve]').forEach(tick);
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
    else { init(); }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_drop-countdown"] && !Shopify.designMode) return;
  try {
    (function(){
    function tick(el){
      var target = new Date(el.dataset.target).getTime();
      var diff = Math.max(0, target - Date.now());
      var days  = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins  = Math.floor((diff % 3600000) / 60000);
      var secs  = Math.floor((diff % 60000) / 1000);
      var pad = function(n){ return String(n).padStart(2, '0'); };
      var d = el.querySelector('[data-vc-days]');  if (d) d.textContent = pad(days);
      var h = el.querySelector('[data-vc-hours]'); if (h) h.textContent = pad(hours);
      var m = el.querySelector('[data-vc-mins]');  if (m) m.textContent = pad(mins);
      var s = el.querySelector('[data-vc-secs]');  if (s) s.textContent = pad(secs);
    }
    function init(){
      document.querySelectorAll('[data-vc-countdown]').forEach(function(el){
        tick(el);
        setInterval(function(){ tick(el); }, 1000);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
  })();
  } catch(e) { console.error(e); }
})();

})();
